import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_heart from '../../static/images_ae/reporting/organ_heart.png';
import doctor_completed from '../../static/images_ae/reporting/doctor_completed.png';
import { withRouter } from 'react-router-dom';
import styles from './completed.module.scss';

const api = new ApiCore();

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>(props.treatments || []);
    const [activeOrgan, setActiveOrgan] = useState<any>('');

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
    }

    const headSelect = () => {
        setHeadSelected(!headSelected);
        setActiveOrgan('heart');
        // const item = organList.filter((item: any) => item.type === 'heart');
        // setSymptoms(item);
    }

    const chestSelect = () => {
        setChestSelected(!chestSelected);
        const item = organList.filter((item: any) => item.type === 'lung');
        setSymptoms(item);
        setActiveOrgan('lung');
    }

    const stomachSelect = () => {
        setStomachSelect(!stomachSelected);
    }

    const othersSelect = () => {
        setOthersSelected(!othersSelected);
    }

    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }

    const symptomsSelected = (val: any, key: number) => {
        let _symptoms: any = symptoms.map((v: any) => {
            let _selected = !!v.selected;
            if (val.code === v.code) {
                _selected = !v.selected;
            }
            return {
                ...v,
                selected: _selected
            }
        });
        setSymptoms(_symptoms)
    }

    const allCompleted = () => {
        const symptomRecords: any = [];
        [
            props.headOrgans,
            props.chestOrgans, 
            props.stomachOrgans, 
            props.limbsOrgans, 
            props.othersOrgans
        ].forEach((item: any) => {
            (item.organs || []).forEach((vv: any) => {
                (vv.symptoms || []).forEach((vvv: any) => {
                    if (vvv.selected) {
                        symptomRecords.push({
                            positionCode: item.code,
                            positionName: item.name,
                            organCode: vv.code,
                            organName: vv.name,
                            symptomCode: vvv.code,
                            symptomName: vvv.code ? vvv.name : vvv.value // 其他
                        })
                    }
                });
            });
        })
        const treatments = symptoms.filter((v: any) => v.selected).map((vv: any) => vv.code).join(';');
        const params = {
            otherTreatment: '',
            symptomRecords,
            treatments
        };
        api.toSaveEvaluation(params).then((res: any) => {
            if (res.code == 0) {
                Toast.show('保存成功');
                props.onCompletedFinished(res.data || {});
            } else {
                Toast.show(res.message || '保存失败');
            }
        })
    }

    const onPopState = (event: any) => {
        props.onBack();
    }


    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            <div className={styles.area_body_container}>
                {/* <img className={styles.area_body} src={reporting_body} alt="" /> */}
                <img src={doctor_completed} alt="" />
                <div>
                    <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : ''}`} onClick={ () => { headSelect()} }>
                        <div className={`${styles.area_tl_l}`}></div>
                        <div className={`${styles.area_tl_t}`}></div>
                        <div className={`${styles.area_tr_r}`}></div>
                        <div className={`${styles.area_tr_t}`}></div>
                        <div className={`${styles.area_bl_l}`}></div>
                        <div className={`${styles.area_bl_b}`}></div>
                        <div className={`${styles.area_br_r}`}></div>
                        <div className={`${styles.area_br_b}`}></div>
                        {/* <div className={styles.area_head_top}>
                            <img className={styles.icon_head} src={organ_lung} alt="" />
                            <div>肺部</div>
                        </div>
                        <div className={styles.area_head_middle}>
                        </div> */}
                        <div className={styles.area_head_bottom}>
                            请你选择出现不良反应期间采用的治疗方式
                        </div>
                        {/* <img  className={styles.line_head} src={line_lungs} alt="" /> */}
                    </div>
                </div>
            </div>
            <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                        {
                            symptoms && symptoms.map((val: any, key: number) => (
                                <div className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                            ))
                        }
                        {/* {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        } */}
                    </div>
                </div>
            </div>
            <div className={styles.btns_wrap}>
                {/* <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.onBack() }}>返回上一步</div>
                </div> */}
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={allCompleted}>选择完成，提交评测</div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Chest);